import React from "react";
import styles from "../Demographics.module.css";
import * as d3 from "d3";

const Age = ({ data, hr_age, setHighestAge }) => {
  const chicagoAge = {
    age_0to9: {
      name: "0-9",
      pop_pct: 0.11,
      homicide_count: 0,
    },
    age_10_19: {
      name: "10-19",
      pop_pct: 0.12,
      homicide_count: 0,
    },
    age_20_29: {
      name: "20-29",
      pop_pct: 0.17,
      homicide_count: 0,
    },
    age_30_39: {
      name: "30-39",
      pop_pct: 0.17,
      homicide_count: 0,
    },
    age_40_49: {
      name: "40-49",
      pop_pct: 0.13,
      homicide_count: 0,
    },
    age_50_59: {
      name: "50-59",
      pop_pct: 0.11,
      homicide_count: 0,
    },
    age_60_69: {
      name: "60-69",
      pop_pct: 0.1,
      homicide_count: 0,
    },
    age_70_79: {
      name: "70-79",
      pop_pct: 0.06,
      homicide_count: 0,
    },
    age_80_plus: {
      name: "80+",
      pop_pct: 0.03,
      homicide_count: 0,
    },
  };

  for (let i = 0; i < data.length; i++) {
    switch (true) {
      case +data[i].age <= 9:
        ++chicagoAge.age_0to9.homicide_count;
        break;
      case +data[i].age <= 19:
        ++chicagoAge.age_10_19.homicide_count;
        break;
      case +data[i].age <= 29:
        ++chicagoAge.age_20_29.homicide_count;
        break;
      case +data[i].age <= 39:
        ++chicagoAge.age_30_39.homicide_count;
        break;
      case +data[i].age <= 49:
        ++chicagoAge.age_40_49.homicide_count;
        break;
      case +data[i].age <= 59:
        ++chicagoAge.age_50_59.homicide_count;
        break;
      case +data[i].age <= 69:
        ++chicagoAge.age_60_69.homicide_count;
        break;
      case +data[i].age <= 79:
        ++chicagoAge.age_70_79.homicide_count;
        break;
      case +data[i].age > 79:
        ++chicagoAge.age_80_plus.homicide_count;
        break;
      default:
      // code block
    }
  }

  const formatNum = (x) => Number.parseFloat(x).toFixed(1);

  const highest_hr_age = d3.max(
    Object.keys(chicagoAge),
    (d) => +chicagoAge[d].homicide_count / data.length
  );

  const selectage = Object.keys(chicagoAge).filter((d) => {
    return +chicagoAge[d].homicide_count / data.length === highest_hr_age;
  });

  // if (!hr_age.name) {
  //   setHighestAge({
  //     name: chicagoAge[selectage].name,
  //     pct: (+chicagoAge[selectage].homicide_count / data.length) * 100,
  //     pop: +chicagoAge[selectage].pop_pct * 100,
  //   });
  // }
  return (
    <table>
      <thead>
        <tr>
          <th>Age</th>
          <th>Total homicides</th>
          <th>Pct. of homicides</th>
          <th>Pct. of population</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(chicagoAge).map((d) => {
          let homicideHighlight;
          let demographicHighlight;
          if (chicagoAge[d]) {
            chicagoAge[d].homicide_count / data.length > chicagoAge[d].pop_pct
              ? (homicideHighlight = styles.Highlight)
              : (demographicHighlight = styles.Highlight);
          }
          return (
            <tr key={d}>
              <td>{chicagoAge[d].name}</td>
              <td>{chicagoAge[d].homicide_count.toFixed(0)}</td>
              <td className={[homicideHighlight, styles.Num].join(" ")}>
                {formatNum((chicagoAge[d].homicide_count / data.length) * 100)}%
              </td>
              <td className={[demographicHighlight, styles.Num].join(" ")}>
                {chicagoAge[d].pop_pct * 100}%
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Age;
